export const FETCH_LOAD_ALL_THERMIT_DATA_GRID_REQUEST = 'FETCH_LOAD_ALL_THERMIT_DATA_GRID_REQUEST'
export const FETCH_LOAD_ALL_THERMIT_DATA_GRID_SUCCESS = 'FETCH_LOAD_ALL_THERMIT_DATA_GRID_SUCCESS'
export const FETCH_LOAD_ALL_THERMIT_DATA_GRID_FALUIRE = 'FETCH_LOAD_ALL_THERMIT_DATA_GRID_FALUIRE'
